export let ColorPickerType = /*#__PURE__*/function (ColorPickerType) {
  ColorPickerType["TEXT"] = "text";
  ColorPickerType["BUTTON"] = "button";
  return ColorPickerType;
}({});
export let ColorPickerApplyMode = /*#__PURE__*/function (ColorPickerApplyMode) {
  ColorPickerApplyMode["ALL"] = "all";
  ColorPickerApplyMode["SELECTION"] = "selection";
  return ColorPickerApplyMode;
}({});